import { Formik } from "formik";
import React, { useState } from "react";
import { useEffect } from "react";
import { Button, Col, Form, Row, Alert } from "react-bootstrap";
import { CREATE_DATA_SOURCE } from "../../../../queries";

// Interface with parent
//
interface DataSettings {
    shouldRefreshSources: Function
}

const RegisterSettingsForm = (props: any) => {
    const [dataOptions, setDataOptions] = useState<any>(null);
    const [showSuccess, setShowSuccess] = useState<any>(false);
    const [showFail, setShowFail] = useState<any>(false);
    
    useEffect(() => {
        (async function fetchData() { // KEEP this logic for now, might use for getting options from DB
            setDataOptions("none"/*resultRoles.data.syncarto_app_role*/);
        })();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const createSource = (sourceData:any) => {
        //console.log("createSource sourceData", sourceData);
        //console.log("createSource props", props);
        /* SCHEMA FOR HASURA data_source TABLE, 10/29/21 
        FORM ELEMENT	        FIELDNAME	            DATA TYPE
            <NOT IN FORM>	        id	                    integer
            dropdown	            data_source_type_id	    integer               // All are presently null but see HASURA data_source_type table for options
            text input	            stac_address	        text
            <NOT IN FORM>	        collection_id	        text
            dropdown	            public_data_catalog_id	integer
            integer input	        process_catalog_id	    integer
            <NOT EDITABLE>	        org_id	                uuid
            date picker	        min_date	            date
            date picker	        max_date	            date
            text input	            title	                text
            <NOT IN FORM>	        extent	                geometry
            dropdown	            is_public	            boolean
            dropdown	            is_ext	                boolean
            text input	            template	            character varying
            text input	            capabilities	        character varying
            text input	            citation	            character varying
            text input	            metadata	            character varying
            integer input	        min_zoom_level	        integer
            integer input	        max_zoom_level	        integer
            dropdown            	stac_query_prefix	    text                   eo:constellation | collection
            dropdown            	date_display_resolution	character varying      day | year
        */
        var data = {
            org_id: props.orgId,
            stac_address: sourceData.stac_address,
            title: sourceData.title,
            collection_id: sourceData.collection_id,
            data_source_type_id: sourceData.data_source_type_id === "" ? null : parseInt(sourceData.data_source_type_id),
            public_data_catalog_id: sourceData.public_data_catalog_id === "" ? null : parseInt(sourceData.public_data_catalog_id),
            process_catalog_id: sourceData.process_catalog_id === "" ? null : parseInt(sourceData.process_catalog_id), 
            min_date: sourceData.min_date,
            max_date: sourceData.max_date,
            is_public: sourceData.is_public,
            is_ext: sourceData.is_ext,
            template: sourceData.template === "" ? null : sourceData.template, // Set to null if left blank
            capabilities: sourceData.capabilities === "" ? null : sourceData.capabilities, // Set to null if left blank
            citation: sourceData.citation === "" ? null : sourceData.citation, // Set to null if left blank
            min_zoom_level: parseInt(sourceData.min_zoom_level),
            max_zoom_level: parseInt(sourceData.max_zoom_level),
            metadata: sourceData.metadata === "" ? null : sourceData.metadata, // Set to null if left blank
            stac_query_prefix: sourceData.stac_query_prefix,
            date_display_resolution: sourceData.date_display_resolution,
            expr: sourceData.expr,
            jq: sourceData.jq,
            color_map: sourceData.color_map,
            color_ramp: sourceData.color_ramp,
            global_min: parseInt(sourceData.global_min),
            global_max: parseInt(sourceData.global_max),
            tile_server: sourceData.tile_server,
        };
        console.log("createSource data", data);
        return props.client.mutate({
            mutation: CREATE_DATA_SOURCE,
            variables: data,
            optimisticResponse: null
        });
    }


    if(dataOptions == null) {
        return (
            <div>Loading...</div>
        )
    }

    const validate = (values:any) => {
        var errors: {[k: string]: any} = {};

        if (values.title === "") {
            errors.title = 'Required';
        }

        if (values.max_zoom_level === "") {
            errors.max_zoom_level = 'Required';
        }

        if (values.min_zoom_level === "") {
            errors.min_zoom_level = 'Required';
        }

        if (values.stac_address === "") {
            errors.stac_address = 'Required';
        }

        if (values.collection_id === "") {
            errors.collection_id = 'Required';
        }

        return errors;
      };

    //return (<div>formik</div>);
    return (
        <Formik 
            initialValues= {{ 
				stac_address: "",
                title: "",
                collection_id: "",
                data_source_type_id: "",//null,
                public_data_catalog_id: "", //null,
                process_catalog_id: "", //null, 
                min_date: "2000-01-01",
                max_date: "2000-01-01",
                is_public: "false", // false
                is_ext: "false", // false
                template: "",
                capabilities: "",
                citation: "",
                min_zoom_level: "20", //20,
                max_zoom_level: "0", //0,
                metadata: "",
                stac_query_prefix: "collection",
                date_display_resolution: "year",
                expr: "",
                jq: "",
                color_map: "",
                color_ramp: "",
                global_min: "0",
                global_max: "0",
                tile_server: "",
            }}
            validateOnChange={false}
            validateOnBlur={false}
            validate={validate}
            onSubmit={async (values, {setSubmitting, resetForm}) => {
                setSubmitting(true);
                
                console.log("submitting...");

                try {
                    let sourceData = {
                        stac_address: values.stac_address,
                        title: values.title,
                        collection_id: values.collection_id,
                        data_source_type_id: values.data_source_type_id,
                        public_data_catalog_id: values.public_data_catalog_id,
                        process_catalog_id: values.process_catalog_id, 
                        min_date: values.min_date,
                        max_date: values.max_date,
                        is_public: values.is_public,
                        is_ext: values.is_ext,
                        template: values.template,
                        capabilities: values.capabilities,
                        citation: values.citation,
                        min_zoom_level: values.min_zoom_level,
                        max_zoom_level: values.max_zoom_level,
                        metadata: values.metadata,
                        stac_query_prefix: values.stac_query_prefix,
                        date_display_resolution: values.date_display_resolution,
                        expr: values.expr,
                        jq: values.jq,
                        color_map: values.color_map,
                        color_ramp: values.color_ramp,
                        global_min: values.global_min,
                        global_max: values.global_max,
                        tile_server: values.tile_server,
                    };
                    console.log("sourceData", sourceData)
    
                    await createSource({...sourceData});

                    setShowSuccess(true);

                    setTimeout(() => {
                        const { shouldRefreshSources } = props;
                        shouldRefreshSources();
                    },500);  

                    setTimeout(() => {
                        setShowSuccess(false);
                    },1500);

                    resetForm();
                } catch(e) {
                    console.error(e);
                    if(e.code) {
                        alert(e.message);
                    }
                    setShowFail(true);
                    setTimeout(() => {
                        setShowFail(false);
                    },1500);
                }
                setSubmitting(false);
            }}
        >
            {({
                values,
                errors,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
            }) => (
                <>
                <h4>Create Catalog</h4>  
                <div style={{marginTop: "10px", padding: "1em", overflowY:"scroll"}}>
                    <Form noValidate onSubmit={handleSubmit} autoComplete="off">                   
                        <Form.Group as={Row} controlId="form_stac_title">
                            <Form.Label column sm="3">
                                Title                    
                            </Form.Label>
                            <Col sm="9">
                                <Form.Control 
                                    type="text" 
                                    name="title"
                                    //placeholder="Enter source's title"
                                    onChange={handleChange/*_title*/} 
                                    value={values.title}
                                    onBlur={handleBlur}
                                    isInvalid={!!errors.title}
                                /> 
                                <Form.Control.Feedback type="invalid">
                                    {errors.title}
                                </Form.Control.Feedback>
                            </Col>
                           
                        </Form.Group>
                        <Form.Group as={Row} controlId="form_stac_address">
                            <Form.Label column sm="3">
                                STAC Address
                            </Form.Label>
                            <Col sm="9">
                                <Form.Control 
                                    type="text" 
                                    name="stac_address"
                                    onChange={handleChange} 
                                    value={values.stac_address}
                                    onBlur={handleBlur}
                                    isInvalid={!!errors.stac_address}
                                />                                
                                <Form.Control.Feedback type="invalid">
                                    {errors.stac_address}
                                </Form.Control.Feedback>
                            </Col>
                        </Form.Group>
                         <Form.Group as={Row} controlId="form_collection_id">
                            <Form.Label column sm="3">
                                Collection ID
                            </Form.Label>
                            <Col sm="9">
                                <Form.Control 
                                    type="text" 
                                    name="collection_id"
                                    onChange={handleChange/*_collection_id*/} 
                                    value={values.collection_id}
                                    onBlur={handleBlur}
                                    isInvalid={!!errors.collection_id}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.collection_id}
                                </Form.Control.Feedback>
                            </Col>
                        </Form.Group>
                       <Form.Group as={Row} controlId="form_data_source_type_id">
                            <Form.Label column sm="3">
                                Data Source Type
                            </Form.Label>
                            <Col sm="9">
                                <Form.Control
                                    as="select"
                                    name="data_source_type_id"
                                    onChange={handleChange/*_data_source_type_id*/}
                                    value={values.data_source_type_id}
                                    onBlur={handleBlur}
                                    isInvalid={!!errors.data_source_type_id}
                                >
                                    {
                                         props.formOptions.optionsFor_data_source_type_id.map((typeId: any) => {
                                            return (
                                                <option key={typeId.id} value={typeId.id}>{typeId.name}</option>
                                            );
                                        })
                                    }
                                </Form.Control>                                
                                <Form.Control.Feedback type="invalid">
                                    {errors.data_source_type_id}
                                </Form.Control.Feedback>   
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="form_public_data_catalog_id">
                            <Form.Label column sm="3">
                                Public Data Catalog
                            </Form.Label>
                            <Col sm="9">
                                <Form.Control disabled // GraphQL error: Foreign key violation. insert or update on table "data_source" violates foreign key constraint "fk_public_data_catalog_id"
                                    as="select"
                                    name="public_data_catalog_id"
                                    onChange={handleChange/*_public_data_catalog_id*/}
                                    value={values.public_data_catalog_id}
                                    onBlur={handleBlur}
                                    isInvalid={!!errors.public_data_catalog_id}
                                >
                                    {
                                         props.formOptions.optionsFor_public_data_catalog_id.map((optionElement: any) => {
                                            return (
                                                <option key={optionElement.id} value={optionElement.id}>{optionElement.catalog_description}</option>
                                            );
                                        })
                                    }
                                </Form.Control>   
                                <Form.Control.Feedback type="invalid">
                                    {errors.public_data_catalog_id}
                                </Form.Control.Feedback>     
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="form_process_catalog_id">
                            <Form.Label column sm="3">
                                Collection ID
                            </Form.Label>
                            <Col sm="9">
                                <Form.Control 
                                    type="number" 
                                    name="process_catalog_id"
                                    onChange={handleChange/*_process_catalog_id*/} 
                                    value={values.process_catalog_id}
                                    onBlur={handleBlur}
                                    isInvalid={!!errors.process_catalog_id}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.process_catalog_id}
                                </Form.Control.Feedback>  
                            </Col>
                        </Form.Group>                
                        <Form.Group as={Row} controlId="form_min_date">
                            <Form.Label column sm="3">
                                Min Date
                            </Form.Label>
                            <Col sm="9">
                                <Form.Control
                                    type="date"
                                    name="min_date"
                                    onChange={handleChange/*_min_date*/}
                                    value={values.min_date}
                                    onBlur={handleBlur}
                                    isInvalid={!!errors.min_date}
                                />                                
                                <Form.Control.Feedback type="invalid">
                                    {errors.min_date}
                                </Form.Control.Feedback> 
                            </Col>
                        </Form.Group>  
                        <Form.Group as={Row} controlId="form_max_date">
                            <Form.Label column sm="3">
                                Max Date
                            </Form.Label>
                            <Col sm="9">
                                <Form.Control 
                                    type="date"
                                    name="max_date"
                                    onChange={handleChange/*_max_date*/}
                                    value={values.max_date}
                                    onBlur={handleBlur}
                                    isInvalid={!!errors.max_date}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.max_date}
                                </Form.Control.Feedback>  
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="form_is_public">
                            <Form.Label column sm="3">
                                Is Public
                            </Form.Label>
                            <Col sm="9">
                                <Form.Control
                                    as="select"
                                    name="is_public"
                                    onChange={handleChange/*_is_public*/}
                                    value={values.is_public}
                                    onBlur={handleBlur}
                                    isInvalid={!!errors.is_public}
                                >
                                    <option key={"true"} value={"true"}>{"True"}</option>
                                    <option key={"false"} value={"false"}>{"False"}</option>
                                </Form.Control>
                                <Form.Control.Feedback type="invalid">
                                    {errors.is_public}
                                </Form.Control.Feedback>        
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="form_is_ext">
                            <Form.Label column sm="3">
                                Is Ext
                            </Form.Label>
                            <Col sm="9">
                                <Form.Control
                                    as="select"
                                    name="is_ext"
                                    onChange={handleChange/*_is_ext*/}
                                    value={values.is_ext}
                                    onBlur={handleBlur}
                                    isInvalid={!!errors.is_ext}
                                >
                                    <option key={"true"} value={"true"}>{"True"}</option>
                                    <option key={"false"} value={"false"}>{"False"}</option>
                                </Form.Control>
                                <Form.Control.Feedback type="invalid">
                                    {errors.is_ext}
                                </Form.Control.Feedback>      
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="form_template">
                            <Form.Label column sm="3">
                                Template
                            </Form.Label>
                            <Col sm="9">
                                <Form.Control 
                                    type="text"
                                    name="template"
                                    onChange={handleChange/*_template*/}
                                    value={values.template}
                                    onBlur={handleBlur}
                                    isInvalid={!!errors.template}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.template}
                                </Form.Control.Feedback>  
                            </Col>
                        </Form.Group>              
                        <Form.Group as={Row} controlId="form_capabilities">
                            <Form.Label column sm="3">
                                Capabilities
                            </Form.Label>
                            <Col sm="9">
                                <Form.Control 
                                    type="text" 
                                    name="capabilities"
                                    onChange={handleChange/*_capabilities*/} 
                                    value={values.capabilities}
                                    onBlur={handleBlur}
                                    isInvalid={!!errors.capabilities}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.capabilities}
                                </Form.Control.Feedback>  
                            </Col>
                        </Form.Group>                 
                        <Form.Group as={Row} controlId="form_citation">
                            <Form.Label column sm="3">
                                Citation
                            </Form.Label>
                            <Col sm="9">
                                <Form.Control
                                    type="text"
                                    name="citation"
                                    onChange={handleChange/*_citation*/}
                                    value={values.citation}
                                    onBlur={handleBlur}
                                    isInvalid={!!errors.citation}
                                />                                
                                <Form.Control.Feedback type="invalid">
                                    {errors.citation}
                                </Form.Control.Feedback>  
                            </Col>
                        </Form.Group>                
                        <Form.Group as={Row} controlId="form_metadata">
                            <Form.Label column sm="3">
                                Metadata
                            </Form.Label>
                            <Col sm="9">
                                <Form.Control 
                                    type="text"
                                    name="metadata"
                                    onChange={handleChange/*_metadata*/}
                                    value={values.metadata}
                                    onBlur={handleBlur}
                                    isInvalid={!!errors.metadata}
                                />                                
                                <Form.Control.Feedback type="invalid">
                                    {errors.metadata}
                                </Form.Control.Feedback>  
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="form_min_zoom_level">
                            <Form.Label column sm="3">
                                Min Zoom Level
                            </Form.Label>
                            <Col sm="9">
                                <Form.Control 
                                    type="number"
                                    name="min_zoom_level"
                                    onChange={handleChange/*_min_zoom_level*/}
                                    value={values.min_zoom_level}
                                    onBlur={handleBlur}
                                    isInvalid={!!errors.min_zoom_level}
                                />                                
                                <Form.Control.Feedback type="invalid">
                                    {errors.min_zoom_level}
                                </Form.Control.Feedback>  
                            </Col>
                        </Form.Group> 
                        <Form.Group as={Row} controlId="form_max_zoom_level">
                            <Form.Label column sm="3">
                                Max Zoom Level
                            </Form.Label>
                            <Col sm="9">
                                <Form.Control
                                    type="number"
                                    name="max_zoom_level"
                                    onChange={handleChange/*_max_zoom_level*/}
                                    value={values.max_zoom_level}
                                    onBlur={handleBlur}
                                    isInvalid={!!errors.max_zoom_level}
                                />                                
                                <Form.Control.Feedback type="invalid">
                                    {errors.max_zoom_level}
                                </Form.Control.Feedback>  
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="form_stac_query_prefix">
                            <Form.Label column sm="3">
                                STAC Query Prefix
                            </Form.Label>
                            <Col sm="9">
                                <Form.Control
                                    as="select"
                                    name="stac_query_prefix"
                                    onChange={handleChange/*_stac_query_prefix*/}
                                    value={values.stac_query_prefix}
                                    onBlur={handleBlur}
                                    isInvalid={!!errors.stac_query_prefix}
                                >
                                    {
                                        props.formOptions.optionsFor_stac_query_prefix.map((optionElement: any) => {
                                            return (
                                                <option key={optionElement.id} value={optionElement.id}>{optionElement.name}</option>
                                            );
                                        })
                                    }
                                </Form.Control>
                                <Form.Control.Feedback type="invalid">
                                    {errors.stac_query_prefix}
                                </Form.Control.Feedback>      
                            </Col>
                        </Form.Group>                
                        <Form.Group as={Row} controlId="form_date_display_resolution">
                            <Form.Label column sm="3">
                                Date Display Resolution
                            </Form.Label>
                            <Col sm="9">
                                <Form.Control
                                    as="select"
                                    name="date_display_resolution"
                                    onChange={handleChange/*_date_display_resolution*/}
                                    value={values.date_display_resolution}
                                    onBlur={handleBlur}
                                    isInvalid={!!errors.date_display_resolution}
                                >
                                    {
                                        props.formOptions.optionsFor_date_display_resolution.map((optionElement: any) => {
                                            return (
                                                <option key={optionElement.id} value={optionElement.id}>{optionElement.name}</option>
                                            );
                                        })
                                    }
                                </Form.Control>
                                <Form.Control.Feedback type="invalid">
                                    {errors.date_display_resolution}
                                </Form.Control.Feedback>        
                            </Col>
                        </Form.Group>
                        {/*
                        expr
                        jq
                        color_map
                        color_ramp
                        global_min
                        global_max
                        tile_server
                        */}
                        <Form.Group as={Row} controlId="form_global_min">
                            <Form.Label column sm="3">
                                Global Min
                            </Form.Label>
                            <Col sm="9">
                                <Form.Control 
                                    type="number"
                                    name="global_min"
                                    onChange={handleChange/*_global_min*/}
                                    value={values.global_min}
                                    onBlur={handleBlur}
                                    isInvalid={!!errors.global_min}
                                />                                
                                <Form.Control.Feedback type="invalid">
                                    {errors.global_min}
                                </Form.Control.Feedback>  
                            </Col>
                        </Form.Group> 
                        <Form.Group as={Row} controlId="form_global_max">
                            <Form.Label column sm="3">
                                Global Max
                            </Form.Label>
                            <Col sm="9">
                                <Form.Control 
                                    type="number"
                                    name="global_max"
                                    onChange={handleChange/*_global_max*/}
                                    value={values.global_max}
                                    onBlur={handleBlur}
                                    isInvalid={!!errors.global_max}
                                />                                
                                <Form.Control.Feedback type="invalid">
                                    {errors.global_max}
                                </Form.Control.Feedback>  
                            </Col>
                        </Form.Group> 
                        <Form.Group as={Row} controlId="form_expr">
                            <Form.Label column sm="3">
                                Expression
                            </Form.Label>
                            <Col sm="9">
                                <Form.Control 
                                    type="text" 
                                    name="expr"
                                    onChange={handleChange} 
                                    value={values.expr}
                                    onBlur={handleBlur}
                                    isInvalid={!!errors.expr}
                                />                                
                                <Form.Control.Feedback type="invalid">
                                    {errors.expr}
                                </Form.Control.Feedback>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="form_jq">
                            <Form.Label column sm="3">
                                JQ
                            </Form.Label>
                            <Col sm="9">
                                <Form.Control 
                                    type="text" 
                                    name="jq"
                                    onChange={handleChange} 
                                    value={values.jq}
                                    onBlur={handleBlur}
                                    isInvalid={!!errors.jq}
                                />                                
                                <Form.Control.Feedback type="invalid">
                                    {errors.jq}
                                </Form.Control.Feedback>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="form_color_map">
                            <Form.Label column sm="3">
                                Color Map
                            </Form.Label>
                            <Col sm="9">
                                <Form.Control 
                                    type="text" 
                                    name="color_map"
                                    onChange={handleChange} 
                                    value={values.color_map}
                                    onBlur={handleBlur}
                                    isInvalid={!!errors.color_map}
                                />                                
                                <Form.Control.Feedback type="invalid">
                                    {errors.color_map}
                                </Form.Control.Feedback>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="form_color_ramp">
                            <Form.Label column sm="3">
                                Color Ramp
                            </Form.Label>
                            <Col sm="9">
                                <Form.Control 
                                    type="text" 
                                    name="color_ramp"
                                    onChange={handleChange} 
                                    value={values.color_ramp}
                                    onBlur={handleBlur}
                                    isInvalid={!!errors.color_ramp}
                                />                                
                                <Form.Control.Feedback type="invalid">
                                    {errors.color_ramp}
                                </Form.Control.Feedback>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="form_tile_server">
                            <Form.Label column sm="3">
                                Tile Server
                            </Form.Label>
                            <Col sm="9">
                                <Form.Control 
                                    type="text" 
                                    name="tile_server"
                                    onChange={handleChange} 
                                    value={values.tile_server}
                                    onBlur={handleBlur}
                                    isInvalid={!!errors.tile_server}
                                />                                
                                <Form.Control.Feedback type="invalid">
                                    {errors.tile_server}
                                </Form.Control.Feedback>
                            </Col>
                        </Form.Group>
                    <Button
                        variant="primary"
                        type="submit"
                        disabled={isSubmitting}
                    >
                        Submit New Catalog
                    </Button>                    
                    <Alert show={showSuccess} variant="success" className="query-success-syncarto">
                        Catalog Created!
                    </Alert>                    
                    <Alert show={showFail} variant="warning" className="query-success-syncarto">
                        There was an issue with creating catalog!
                    </Alert>
                    </Form>
                </div>
                </>
            )}
        </Formik>   
    );
}

export default RegisterSettingsForm;